import type { JSX } from 'react';
/* eslint-disable jsx-a11y/alt-text */

interface LinkedInTrackerProps {
    partnerId: string;
}

/**
 * LinkedIn Insight Tag script half. The matching `<noscript><img>` half lives in
 * `LinkedInTrackerBody` and is SSR-rendered from `BodyPixels`.
 */
export const LinkedInTrackerHead = ({
    partnerId,
}: LinkedInTrackerProps): JSX.Element => {
    const partnerSetup = `
        _linkedin_partner_id = "${partnerId}";
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
    `;
    const loader = `
        (function(l) {
            if (!l) {
                window.lintrk = function(a, b) {
                    window.lintrk.q.push([a, b]);
                };
                window.lintrk.q = [];
            }
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";
            b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);
        })(window.lintrk);
    `;

    return (
        <>
            <script
                suppressHydrationWarning
                defer
                dangerouslySetInnerHTML={{
                    __html: partnerSetup,
                }}
            />
            <script
                suppressHydrationWarning
                defer
                dangerouslySetInnerHTML={{
                    __html: loader,
                }}
            />
        </>
    );
};

export const LinkedInTrackerBody = ({
    partnerId,
}: LinkedInTrackerProps): JSX.Element => {
    return (
        <noscript>
            <img
                height="1"
                width="1"
                style={{ display: 'none' }}
                alt=""
                src={`https://px.ads.linkedin.com/collect/?pid=${partnerId}&fmt=gif`}
            />
        </noscript>
    );
};
